import React, { useState, memo } from 'react';
import { Platform } from 'react-native';
import { useTranslation } from 'react-i18next';

import { Interactable, Text, View } from '@24i/nxg-sdk-quarks';
import { useTheme } from '@24i/nxg-sdk-higgs';
import IconButton from '@24i/nxg-sdk-gluons/src/components/buttons/IconButton';

import type { SectionHeaderProps } from './types';

const SectionHeader: React.FC<SectionHeaderProps> = ({
    title,
    onSeeAll,
    seeAllText,
    styles = {},
    testID,
}) => {
    const [hovered, setHovered] = useState(false);
    const { theme } = useTheme();
    const { t } = useTranslation(['sott']);

    const sectionTitleStyle = styles.title;
    const renderTitle =
        typeof title === 'string' ? (
            <Text style={[sectionTitleStyle]} testID={testID}>
                {title}
            </Text>
        ) : (
            title
        );

    // Only show pointer cursor if onSeeAll is present and on web
    const isWeb = typeof window !== 'undefined' && typeof document !== 'undefined';
    const containerProps = onSeeAll
        ? {
              as: Interactable,
              activeOpacity: 1,
              onPress: onSeeAll,
              onMouseEnter: () => setHovered(true),
              onMouseLeave: () => setHovered(false),
              style: isWeb
                  ? { cursor: 'pointer', ...styles.titleContainer }
                  : styles.titleContainer,
          }
        : {
              style: isWeb
                  ? { cursor: 'default', ...styles.titleContainer }
                  : styles.titleContainer,
          };

    const SeeAllAndTitleContainer = onSeeAll && !Platform.isTV ? Interactable : View;

    return (
        <SeeAllAndTitleContainer {...containerProps}>
            {renderTitle}
            {onSeeAll && (
                <View>
                    <IconButton
                        testID={`${testID}.seeAll`}
                        iconName="onPrimary-subpage"
                        onPress={onSeeAll}
                        color={theme.color.textPrimary}
                        iconSize={24}
                        title={seeAllText || t('asset.showAll')}
                        additionalTitleStyles={styles.seeAllButtonTitle}
                        additionalContainerStyles={[
                            styles.seeAllButtonContainer,
                            hovered && styles.seeAllHovered,
                        ]}
                    />
                </View>
            )}
        </SeeAllAndTitleContainer>
    );
};

export default memo(SectionHeader);
